import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { IP } from '@model/ftf-api.model';

@Component({
  selector: 'ip-icon',
  templateUrl: './ip-icon.component.html',
  styleUrls: ['./ip-icon.component.scss'],
  imports: [
    MatIcon,
    NgClass
  ],
})
export class IpIconComponent {
  @Input({ required: true }) ipType!: IP.TrifTypeEnum | IP.TypeEnum | string;
}
